var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageWrapper bg-color-secondary"},[_c('div',{staticClass:"faqs"},[_c('HelpTopics',{attrs:{"hiddenCategories":[_vm.isWebsiteLevel2 ? 'Video guides': '']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }